/* src/app/app.component.scss */
body,
html {
  width: 100%;
  height: 100%;
  background-color: #380415;
  background-repeat: repeat-x;
  background-attachment: fixed;
  background-image: url(data:image/svg+xml;utf8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20100%201000%22%3E%3Crect%20fill%3D%22%23380415%22%20width%3D%22100%22%20height%3D%221000%22%2F%3E%3Cg%20fill-opacity%3D%221%22%3E%3Ccircle%20%20fill%3D%22%23380415%22%20cx%3D%2250%22%20cy%3D%220%22%20r%3D%2250%22%2F%3E%3Cg%20fill%3D%22%233b0416%22%20%3E%3Ccircle%20cx%3D%220%22%20cy%3D%2250%22%20r%3D%2250%22%2F%3E%3Ccircle%20cx%3D%22100%22%20cy%3D%2250%22%20r%3D%2250%22%2F%3E%3C%2Fg%3E%3Ccircle%20%20fill%3D%22%233f0418%22%20cx%3D%2250%22%20cy%3D%22100%22%20r%3D%2250%22%2F%3E%3Cg%20fill%3D%22%23420519%22%20%3E%3Ccircle%20cx%3D%220%22%20cy%3D%22150%22%20r%3D%2250%22%2F%3E%3Ccircle%20cx%3D%22100%22%20cy%3D%22150%22%20r%3D%2250%22%2F%3E%3C%2Fg%3E%3Ccircle%20%20fill%3D%22%2345051b%22%20cx%3D%2250%22%20cy%3D%22200%22%20r%3D%2250%22%2F%3E%3Cg%20fill%3D%22%2349051c%22%20%3E%3Ccircle%20cx%3D%220%22%20cy%3D%22250%22%20r%3D%2250%22%2F%3E%3Ccircle%20cx%3D%22100%22%20cy%3D%22250%22%20r%3D%2250%22%2F%3E%3C%2Fg%3E%3Ccircle%20%20fill%3D%22%234c051d%22%20cx%3D%2250%22%20cy%3D%22300%22%20r%3D%2250%22%2F%3E%3Cg%20fill%3D%22%234f061f%22%20%3E%3Ccircle%20cx%3D%220%22%20cy%3D%22350%22%20r%3D%2250%22%2F%3E%3Ccircle%20cx%3D%22100%22%20cy%3D%22350%22%20r%3D%2250%22%2F%3E%3C%2Fg%3E%3Ccircle%20%20fill%3D%22%23530620%22%20cx%3D%2250%22%20cy%3D%22400%22%20r%3D%2250%22%2F%3E%3Cg%20fill%3D%22%23560621%22%20%3E%3Ccircle%20cx%3D%220%22%20cy%3D%22450%22%20r%3D%2250%22%2F%3E%3Ccircle%20cx%3D%22100%22%20cy%3D%22450%22%20r%3D%2250%22%2F%3E%3C%2Fg%3E%3Ccircle%20%20fill%3D%22%235a0622%22%20cx%3D%2250%22%20cy%3D%22500%22%20r%3D%2250%22%2F%3E%3Cg%20fill%3D%22%235d0624%22%20%3E%3Ccircle%20cx%3D%220%22%20cy%3D%22550%22%20r%3D%2250%22%2F%3E%3Ccircle%20cx%3D%22100%22%20cy%3D%22550%22%20r%3D%2250%22%2F%3E%3C%2Fg%3E%3Ccircle%20%20fill%3D%22%23610725%22%20cx%3D%2250%22%20cy%3D%22600%22%20r%3D%2250%22%2F%3E%3Cg%20fill%3D%22%23640726%22%20%3E%3Ccircle%20cx%3D%220%22%20cy%3D%22650%22%20r%3D%2250%22%2F%3E%3Ccircle%20cx%3D%22100%22%20cy%3D%22650%22%20r%3D%2250%22%2F%3E%3C%2Fg%3E%3Ccircle%20%20fill%3D%22%23680728%22%20cx%3D%2250%22%20cy%3D%22700%22%20r%3D%2250%22%2F%3E%3Cg%20fill%3D%22%236c0729%22%20%3E%3Ccircle%20cx%3D%220%22%20cy%3D%22750%22%20r%3D%2250%22%2F%3E%3Ccircle%20cx%3D%22100%22%20cy%3D%22750%22%20r%3D%2250%22%2F%3E%3C%2Fg%3E%3Ccircle%20%20fill%3D%22%236f082a%22%20cx%3D%2250%22%20cy%3D%22800%22%20r%3D%2250%22%2F%3E%3Cg%20fill%3D%22%2373082b%22%20%3E%3Ccircle%20cx%3D%220%22%20cy%3D%22850%22%20r%3D%2250%22%2F%3E%3Ccircle%20cx%3D%22100%22%20cy%3D%22850%22%20r%3D%2250%22%2F%3E%3C%2Fg%3E%3Ccircle%20%20fill%3D%22%2377082d%22%20cx%3D%2250%22%20cy%3D%22900%22%20r%3D%2250%22%2F%3E%3Cg%20fill%3D%22%237a092e%22%20%3E%3Ccircle%20cx%3D%220%22%20cy%3D%22950%22%20r%3D%2250%22%2F%3E%3Ccircle%20cx%3D%22100%22%20cy%3D%22950%22%20r%3D%2250%22%2F%3E%3C%2Fg%3E%3Ccircle%20%20fill%3D%22%237E092F%22%20cx%3D%2250%22%20cy%3D%221000%22%20r%3D%2250%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E);
}
body {
  font-family:
    Merriweather,
    Garamond,
    Georgia,
    serif;
  font-display: swap;
}
a {
  color: #380415;
  -webkit-transition: all 0.2s;
  -moz-transition: all 0.2s;
  transition: all 0.2s;
}
a:hover {
  color: rgb(8.4, 0.6, 3.15);
}
h1#titulo {
  text-shadow: 2px 2px 4px #000000;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-family:
    Raleway,
    "Helvetica Neue",
    Arial,
    sans-serif;
  font-display: swap;
}
.bg-dark {
  background-color: #212529 !important;
}
.text-faded {
  color: rgba(255, 255, 255, 0.7);
}
section {
  padding: 0 0;
  background-color: white;
}
.section-heading {
  margin-top: 0;
}
.section-footer {
  margin-bottom: 0;
}
::-moz-selection {
  color: white;
  background: #212529;
  text-shadow: none;
}
::selection {
  color: white;
  background: #212529;
  text-shadow: none;
}
img::selection {
  color: white;
  background: transparent;
}
img::-moz-selection {
  color: white;
  background: transparent;
}
.recurso-caixa {
  border-width: 2px;
  border-color: #380415;
}
*,
*::after,
*::before {
  -webkit-font-smoothing: antialiased;
  box-sizing: border-box;
}
.hidden {
  display: none;
}
.hash {
  font-size: 8px;
}
.text-primary {
  color: #380415 !important;
}
.btn {
  font-weight: 700;
  text-transform: uppercase;
  border: none;
  border-radius: 300px;
  font-family:
    Raleway,
    "Helvetica Neue",
    Arial,
    sans-serif;
  font-display: swap;
}
.btn-xl {
  padding: 1rem 2rem;
}
.btn-primary {
  background-color: #380415;
  cursor: pointer;
  border-color: #380415;
}
.btn-primary:hover,
.btn-primary:focus,
.btn-primary:active {
  color: #fff;
  background-color: rgb(32.2, 2.3, 12.075) !important;
}
.btn-primary:active,
.btn-primary:focus {
  box-shadow: 0 0 0 0.2rem #da8505 !important;
}
header.masthead {
  background-image: url("./media/header-YNALEB7P.jpg");
  background-position: center center;
  background-color: #380415;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
header.masthead hr {
  margin: 3rem auto 3rem auto;
  max-width: 50vw;
}
header.masthead h1 {
  font-size: 2rem;
}
header.masthead p {
  font-weight: 300;
}
@media (min-width: 768px) {
  header.masthead p {
    font-size: 1.15rem;
  }
}
@media (min-width: 992px) {
  header.masthead {
    height: 100vh;
    min-height: 650px;
    padding-top: 0;
    padding-bottom: 0;
  }
  header.masthead h1 {
    font-size: 3rem;
  }
}
@media (min-width: 1200px) {
  header.masthead h1 {
    font-size: 4rem;
  }
}
header.banner {
  background-image: none;
}
header.banner div {
  display: none;
}
div.mid-class {
  min-height: calc(100vh - 5rem);
}
@media (max-width: 500px) {
  div.mid-class {
    font-size: 12px;
  }
}
.snack-all {
  z-index: 2000 !important;
}
.snack-success {
  color: white;
}
.snack-success .mat-simple-snackbar-action {
  color: #9567e3;
}
.snack-error {
  color: #da8505;
}
.snack-error .mat-simple-snackbar-action {
  color: red;
}
.folha-back {
  width: 100%;
  max-width: 100vw;
  background-color: transparent;
  min-height: calc(100vh - 5rem);
}
.banner-container {
  transition:
    min-height 400ms ease-out,
    height 400ms ease-out,
    opacity 400ms ease-out;
  display: block;
}
.state-full {
  min-height: 650px;
  opacity: 1;
}
.state-small {
  min-height: 2.9rem;
  height: 2.9rem;
  opacity: 0.9;
}
/*# sourceMappingURL=app.component-ZHPFB7EF.css.map */
